/**
 * Sorts items so the user's pinned spaces/projects appear in the same order as
 * the pins response, while preserving the incoming relative order of non-pinned items.
 */
export function sortPinnedFirst(items, pinnedUuids) {
    if (pinnedUuids.length === 0) {
        return [...items];
    }
    const pinOrderByUuid = new Map(pinnedUuids.map((uuid, index) => [uuid, index]));
    const getPinOrder = (uuid) => pinOrderByUuid.get(uuid) ?? pinnedUuids.length;
    const pinned = items
        .filter((item) => pinOrderByUuid.has(item.uuid))
        .sort((a, b) => getPinOrder(a.uuid) - getPinOrder(b.uuid));
    const rest = items.filter((item) => !pinOrderByUuid.has(item.uuid));
    return [...pinned, ...rest];
}
//# sourceMappingURL=sortPinnedFirst.js.map